import React from 'react';
import styled from '@emotion/styled';
import Link from 'next/link';

const text = {
  askSignup: '회원이 아니신가요?',
  signup: '회원가입',
  askEmail: '이메일을 잊으셨나요?',
  findEmail: '이메일 찾기',
  askPassword: '비밀번호를 잊으셨나요?',
  findPassword: '비밀번호 찾기',
};

export const LinkComponent = () => {
  return (
    <LinkContainer>
      <LinkWarp>
        <span>{text.askSignup}</span>
        <Link href='signup'>{text.signup}</Link>
      </LinkWarp>
      <LinkWarp>
        <span>{text.askEmail}</span>
        <Link href='/user/recovery/email'>{text.findEmail}</Link>
      </LinkWarp>
      <LinkWarp>
        <span>{text.askPassword}</span>
        <Link href='/user/recovery/password'>{text.findPassword}</Link>
      </LinkWarp>
    </LinkContainer>
  );
};

const LinkContainer = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LinkWarp = styled.div`
  font-size: 18px;
  margin-top: 10px;

  a {
    margin-left: 0.5rem;
    text-decoration: underline;
    color: #002366;
  }
  a:hover {
    font-weight: 500;
  }
  @media only screen and (max-width: 992px) {
    font-size: 1rem;
  }
`;
